import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { selectQuestionObjectsForBoard } from "../../gameboard/gameBoardSlice";
import { selectGameId } from "../../gamestate/gameStateSlice";
import Provider from "provider";

const BoardTable = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
});

const HeaderCell = styled('th')(({ theme }) => ({
  backgroundColor: '#1a237e',
  color: '#fff',
  padding: theme.spacing(0.5),
  fontSize: '0.75rem',
  fontWeight: 'bold',
  textAlign: 'center',
  border: '2px solid #000',
  textTransform: 'uppercase',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

const ValueCell = styled('td')(({ picked }) => ({
  padding: '4px',
  fontSize: '0.85rem',
  fontWeight: 'bold',
  textAlign: 'center',
  border: '2px solid #000',
  cursor: 'pointer',
  userSelect: 'none',
  backgroundColor: picked ? '#9e9e9e' : '#00695c',
  color: picked ? '#616161' : '#ffd740',
  '&:hover': {
    opacity: 0.8,
  },
}));

const MiniGameBoard = () => {
  const boardData = useSelector(selectQuestionObjectsForBoard);
  const gameId = useSelector(selectGameId);

  if (!boardData || !boardData.categories) {
    return <Typography variant="body2" color="text.secondary">No round data</Typography>;
  }

  const { categories, ...rows } = boardData;

  const handleClick = async (question) => {
    if (question.picked) {
      await Provider.resetQuestion(gameId, question.id);
    } else {
      await Provider.markQuestionPicked(gameId, question.id);
    }
  };

  const handleContextMenu = async (e, question) => {
    e.preventDefault();
    if (question.picked) {
      await Provider.resetQuestion(gameId, question.id);
    }
  };

  return (
    <BoardTable>
      <thead>
        <tr>
          {categories.map((cat, idx) => (
            <HeaderCell key={idx}>{cat.label}</HeaderCell>
          ))}
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5].map((rowNum) => {
          const rowQuestions = rows[rowNum];
          if (!rowQuestions || rowQuestions.length === 0) return null;
          return (
            <tr key={rowNum}>
              {rowQuestions.map((q) => (
                <ValueCell
                  key={q.id}
                  picked={q.picked ? 1 : 0}
                  onClick={() => handleClick(q)}
                  onContextMenu={(e) => handleContextMenu(e, q)}
                >
                  ${q.value}
                </ValueCell>
              ))}
            </tr>
          );
        })}
      </tbody>
    </BoardTable>
  );
};

export default MiniGameBoard;
